import Vue from 'vue'
import Aegis from 'aegis-web-sdk'
import { init as initSentry, captureException } from '@sentry/browser'
import { ls, isProd } from '@/utils/index'
import { CACHE_USERNAME } from '@/store/modules/user'

const username = ls.getItem(CACHE_USERNAME, '')
let aegis

export default function monitor() {
  if (isProd()) {
    aegis = new Aegis({
      id: 'RraqyNSgJOVBIaFZZl', // 项目key
      uin: username, // 用户唯一 ID（可选）
      version: process.env.VUE_APP_VERSION, // 项目版本（可选）默认SDK版本号
      reportApiSpeed: true, // 接口测速
      reportAssetSpeed: true, // 静态资源测速
      spa: true, // spa 页面需要开启，页面切换的时候上报pv
      beforeRequest: function(data) {
        const url = data.logs.url
        if (data.logType === 'speed' && data.logs.type === 'static') {
          if (url.includes('.js') || url.includes('.css') || url.includes('.woff')) {
            return data
          }

          return false
        }
        return data
      }
    })

    initSentry({
      app: Vue,
      dsn: 'https://f68bf635fa9e43959676326b01d8e33b@tamaegis.com/sentry/1140',
      release: process.env.VUE_APP_VERSION,
      integrations: [],
      trackComponents: true,
      // Decides whether SDK should call Vue's original logError function as well.
      logErrors: true,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
  } else {
    aegis = {
      setConfig: function() {},
      report: function() {},
      log: console.log.bind(console)
    }
  }

  Vue.$aegis = aegis
  Vue.prototype.$aegis = aegis

  Vue.captureException = captureException
  Vue.prototype.$captureException = captureException
}

export {
  aegis
}
